import {
  AccordionItem,
  Text,
  List,
  Stack,
  Strong,
  Heading,
} from 'braid-design-system';
export const SectionA = () => (
  <AccordionItem id="section-a" label="Section A: Talent Search Connect">
    <Stack space="gutter">
      <List type="number" start={62}>
        <Text>
          Section A applies if you have chosen the Talent Search Connect
          functionality through the SEEK API.
        </Text>
        <Stack space="medium">
          <Text>In this Section A:</Text>
          <List type="alpha">
            <Text>
              <Strong>Defect</Strong> means a failure of the Talent Search
              Connect integration to operate in accordance with our requirements
              as set out in the Proactive Sourcing section of the SEEK Developer
              Site.
            </Text>
            <Text>
              <Strong>Storybook</Strong> is a frontend workshop for building
              user interface components.
            </Text>
            <Text>
              <Strong>Widget</Strong> means the features or elements of the
              Talent Search Connect experience that we require you to display in
              your Recruitment Software in connection with making Talent Search
              Connect available to Mutual Customers.
            </Text>
          </List>
        </Stack>
      </List>
      <Heading level="4">Functional</Heading>
      <List type="number" start={64}>
        <Text>
          Within 72 hours of us notifying you that a Mutual Customer has
          purchased access to Talent Search Connect, you must enable Talent
          Search Connect for the Mutual Customer.
        </Text>
        <Stack space="medium">
          <Text>
            At all times, you must ensure that the following Talent Search
            Connect functionality is enabled for Mutual Customers:
          </Text>
          <List type="alpha">
            <Stack space="medium">
              <Text>
                all applicable Widgets are embedded in visible, logical
                locations in the Mutual Customer’s hiring workflow within your
                user interface, including, but not limited to:
              </Text>
              <List type="roman">
                <Text>the Candidate’s Profile;</Text>
                <Text>job requisition creation and job management; and</Text>
                <Text>
                  global navigation to the Talent Search Connect entry point;
                </Text>
              </List>
            </Stack>
            <Text>
              the ability to share Mutual Customer’s active/open jobs within
              your Recruitment Software (irrespective of whether it is
              advertised with us) via the SEEK API;
            </Text>
            <Text>
              the ability to share Mutual Customer’s Candidate Profiles and
              previous interactions with these Candidates via the SEEK API;
            </Text>
            <Text>
              that shared job, Candidate and interaction data is made available
              to us within 60 seconds of the change taking place in your
              Recruitment Software;
            </Text>
            <Text>
              the importing of a Candidate Profile or resume purchased from
              Talent Search Connect into your Recruitment Software and, where
              position data is included as part of the Profile purchase payload,
              the appropriate job; and
            </Text>
            <Text>
              that purchased Profiles must be viewable by the Mutual Customer in
              your Recruitment Software within 60 seconds of receiving a
              purchase event notification from us.
            </Text>
          </List>
        </Stack>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={66}>
        <Text>
          You must ensure that all Widgets are placed in easily discoverable
          locations within the Mutual Customer’s hiring workflow with respect to
          the context of each Widget’s individual functionality. We will provide
          general guidance for appropriate locations for each Widget in the
          Proactive Sourcing section of the SEEK Developer Site.
        </Text>
        <Text>
          You must ensure that each Widget’s minimum size as specified in
          Storybook is respected and is not obscured or obstructed by other
          elements in your user interface.
        </Text>
        <Text>
          You must promptly notify us if you make any significant changes to the
          user interface that may affect the Talent Search Connect functionality
          and the positioning of any Widgets.
        </Text>
        <Text>
          We may at any time update or change the content of the Talent Search
          Connect Widgets at its own discretion.
        </Text>
        <Text>
          Upon successfully integrating Talent Search Connect with your
          Recruitment Software, we will review your implementation to ensure it
          appropriately represents our brand and value proposition. We may
          review the implementation from time to time and require you to fix any
          Defects found within 30 days of being notified. We may decide to end
          your integration with Talent Search Connect if it determines, at our
          sole discretion, that the implementation by you does not appropriately
          represent our brand and value proposition.
        </Text>
      </List>
      <Heading level="4">Offboarding</Heading>
      <List type="number" start={71}>
        <Stack space="medium">
          <Text>
            Within 15 days of us notifying you that a Mutual Customer no longer
            has access to Talent Search Connect you must work with us to
            offboard the Mutual Customer, including to:
          </Text>
          <List type="alpha">
            <Text>disable the Talent Search Connect integration;</Text>
            <Text>
              remove any available Widgets from your Recruitment Software; and
            </Text>
            <Text>cease sending us any applicable Mutual Customer data.</Text>
          </List>
        </Stack>
      </List>
    </Stack>
  </AccordionItem>
);
